export default __webpack_public_path__ + "static/media/DHI_Logo.8f903f18.png";